import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

// 分页拉取施工库
export const queryConstructionItem = async (data) => {
  return request(`${UrlConfig.PmsWeb.QueryConstructionItem}?pageId=${data.pageId}&pageSize=${data.pageSize}`, {
    method: METHODS.POST,
    data
  })
}

// 施工库-分类树
export const queryconstructionItemCategory = async (data) => {
  return request(UrlConfig.PmsWeb.QueryconstructionItemCategory, {
    method: METHODS.POST,
    data
  })
}

// 施工库-选择提交
export const chooseSubmit = async (data, callback = (progress: any) => {}) => {
  return request(UrlConfig.PmsWeb.ChooseSubmit, {
    method: METHODS.POST,
    data,
    onUploadProgress: (e) => {
      if (typeof e.progress !== 'undefined') {
        callback(e.progress * 100)
      }
    },
  })
}

// 施工库-全部提交
export const allSubmit = async (data, callback = (progress: any) => {}) => {
  return request(UrlConfig.PmsWeb.AllSubmit, {
    method: METHODS.POST,
    data,
    onUploadProgress: (e) => {
      if (typeof e.progress !== 'undefined') {
        callback(e.progress * 100)
      }
    },
  })
}

// 获取项目列表
export const getProjectList = async (options: any) => {
  return request(UrlConfig.PmsWeb.GetProjectList, {
    method: METHODS.POST,
    ...options
  })
}

export const salesBenchJumpToProject = async (data: any) => {
  return request(UrlConfig.PmsWeb.SalesBenchJumpToProject, {
    method: METHODS.POST,
    data
  })
}